import { seriesPoints } from "@/mocks/series";
import SectionHeading from "./SectionHeading";

export default function SeriesSection() {
  return (
    <section
      id="series"
      className="section-anchor w-full bg-foreground-950 text-background-100"
    >
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-widest uppercase text-accent-400">
              <i className="ri-subtract-line"></i>
              系列电影
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              潘金莲系列电影：为什么会有这么多版本
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/90">
              所谓“系列电影”，不是指有一个统一的制作计划，而是指同一题材在不同年代、不同团队手中被反复拍摄，
              逐渐形成片名相近、彼此可对照的一组作品。理解它为何不断出现，有助于你更高效地选择想看的版本。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">
            <div className="lg:col-span-5">
              <div className="w-full h-[280px] md:h-[440px] rounded-lg overflow-hidden border border-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20stacked%20vintage%20film%20canisters%20and%20a%20projector%20beam%2C%20warm%20paper%20texture%2C%20deep%20vermillion%20and%20gold%20accents%20on%20dark%20background%2C%20archival%20cinematic%20mood%2C%20no%20text&width=1000&height=1300&seq=pjl-series&orientation=portrait"
                  alt="水墨风格的旧胶片盘与放映光束，象征系列电影的多个版本"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {seriesPoints.map((p) => (
                <article
                  key={p.id}
                  className="rounded-lg bg-background-50/5 border border-background-800 p-5"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-background-50">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-200/80">
                    {p.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}